(function ViewBooking($, Adzuki)
{
	'use strict';

	$(document).ready(function onDocumentReady()
	{
		Adzuki.onload('FlightBooking/viewBooking', function onload()
		{
			// click on flight rules link
			$('.flight-rules-btn').on('click', function onFlightRulesBtnClick(event)
			{
				event.preventDefault();

				$('.modal-title').text('Rules');
				$('.modal-body').html($('.flight-rules').html());
				$('.modal').modal('show');
			});
		});
	});

}(jQuery, window.Adzuki || {}));
